import ReactGA from "react-ga4";

export const initGA = (measurementId) => {
  ReactGA.initialize(measurementId);
};

export const logPageView = () => {
  if (!isLocalhost()) {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }
};

export const logEvent = (category, action, label) => {
  if (!isLocalhost()) {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  }
};

const isLocalhost = () => {
  return window.location.hostname === "localhost" || 
         window.location.hostname === "127.0.0.1";
};
